import { useEffect, useState } from 'react';

export const useInView = (
  element: HTMLElement | Element | null | undefined,
  configs?: {
    options?: IntersectionObserverInit;
    destructOnFirstIntersect?: boolean;
  }
): boolean => {
  const [inView, setInView] = useState(false);

  useEffect(() => {
    if (!element) {
      return;
    }

    const callback = ([entry]: IntersectionObserverEntry[]) => {
      if (configs?.destructOnFirstIntersect && entry.isIntersecting) {
        observer.unobserve(element);
        observer.disconnect();
      }

      setInView(prev => {
        if (prev === entry.isIntersecting) {
          return prev;
        }

        return entry.isIntersecting;
      });
    };

    const observer = new IntersectionObserver(callback, configs?.options);

    observer.observe(element);

    return () => {
      if (!element) {
        return;
      }

      observer.unobserve(element);
      observer.disconnect();
    };
  }, [element, configs?.options, configs?.destructOnFirstIntersect]);

  return inView;
};
